import {
  getCachedProductMetafields,
  findSection,
  updateFilterCounts,
} from "./bundler-utils.js";

/**
 * Function to create a filter for the token section
 *
 * @param {Object} bundle
 * @param {Object} e
 */
export async function createFilter(bundle, e) {
  console.log("▶ createFilter called");
  // Fetch all metafields
  const productMetafields = await getCachedProductMetafields();

  const sectionObj = findSection(bundle, {
    id: 251404,
    name: "Audio-Token",
  });
  if (!sectionObj || sectionObj.index == null) return;
  const section = sectionObj.section;

  // Build a set of handles from section.products
  const handlesInSection = new Set(
    Object.values(section.products)
      .map((p) => p.handle)
      .filter(Boolean)
  );

  // Filter metafields to only those in the section
  const filteredMetafields = {};
  for (const handle of handlesInSection) {
    if (productMetafields[handle]) {
      filteredMetafields[handle] = productMetafields[handle];
    }
  }

  // Generate filter configs based on filtered products
  const filterConfigs = generateFilterConfigs(filteredMetafields);

  // === CREATE FILTER CONTAINER ===
  const sectionEl = document.querySelector(
    `.bndlr-sectioned-section[data-bundler-section="${sectionObj.index}"]`
  );
  if (!sectionEl) return;

  // Remove old filter container if present
  const oldContainer = sectionEl.querySelector(".bndlr-filter-container");
  if (oldContainer) oldContainer.remove();

  // Main container
  const filterContainer = document.createElement("div");
  filterContainer.className = "bndlr-filter-container";

  // Filter-Control-Container
  const controlDiv = document.createElement("div");
  controlDiv.className = "cc-filters-control md-up-hidden no-js-hidden";
  controlDiv.innerHTML = `
        <button type="button" class="cc-filters-control__btn js-show-filters">
          ${theme.strings.filterButton}
        </button>
        <button type="button" class="cc-filters-control__btn js-show-sort">
          ${theme.strings.sortButton}
        </button>
      `;
  // Keep a stable base label for the refine button (used on mobile)
  const refineBtn = controlDiv.querySelector(".js-show-filters");
  if (refineBtn) {
    // Store base label once (e.g., "Verfeinern")
    refineBtn.dataset.baseLabel = refineBtn.textContent.trim();
  }
  filterContainer.appendChild(controlDiv);

  // --- Prevent theme.js FacetFiltersInstance from hijacking the clicks ---
  // We bind in CAPTURE phase and stop propagation, so the global listener never runs.
  const btnShowFilters = controlDiv.querySelector(".js-show-filters");
  const btnShowSort    = controlDiv.querySelector(".js-show-sort");

  function openFiltersPanel() {
    document.body.classList.add("filters-open");
    const sortPanel    = filterContainer.querySelector(".cc-filter--sort");
    const filtersPanel = filterContainer.querySelector(".cc-filters");
    if (sortPanel)  { sortPanel.classList.remove("is-open"); sortPanel.open = false; }
    if (filtersPanel) { filtersPanel.classList.add("is-open"); }
  }

  function openSortPanel() {
    document.body.classList.add("filters-open");
    const filtersPanel = filterContainer.querySelector(".cc-filters");
    const sortPanel    = filterContainer.querySelector(".cc-filter--sort");
    if (filtersPanel) { filtersPanel.classList.remove("is-open"); }
    if (sortPanel) {
      sortPanel.open = true;
      setTimeout(() => sortPanel.classList.add("is-open"), 10);
    }
  }

  // Capture + stop: block theme.js listeners on the same element
  if (btnShowFilters) {
    btnShowFilters.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopImmediatePropagation();
      e.stopPropagation();
      openFiltersPanel();
    }, true); // <- capture
  }

  if (btnShowSort) {
    btnShowSort.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopImmediatePropagation();
      e.stopPropagation();
      openSortPanel();
    }, true); // <- capture
  }

  // Filter container
  const filtersContainer = document.createElement("div");
  filtersContainer.className = "cc-filters-container";

  // Filter elements
  const filtersInner = document.createElement("div");
  filtersInner.className = "cc-filters";
  const filtersItems = document.createElement("div");
  filtersItems.className = "cc-filters__items";

  // Add checkbox filters dynamically
  filterConfigs.forEach((config, idx) => {
    const filterEl = createCheckboxFilterElement({
      index: idx + 1,
      title: config.title,
      name: config.name,
      options: config.options,
    });
    wireCheckboxFilter(filterEl, {
      onChange(selectedValues) {
        sectionEl.dispatchEvent(
          new CustomEvent("galakto:filter-changed", {
            bubbles: true,
            detail: {
              filterType: config.title,
              name: config.name,
              values: selectedValues,
            },
          })
        );
      },
    });
    filtersItems.appendChild(filterEl);
  });

  const filterHeader = document.createElement("div");
  filterHeader.className = "cc-filter__header md-up-hidden";
  filterHeader.innerHTML = `
        <div class="cc-filter-heading">${theme.strings.filterTitle}</div>
        <a href="#" class="cc-filter-clear-btn js-clear-filters" hidden>${theme.strings.clearFilter}</a>
        <button type="button" class="cc-filter-close-btn feather-icon js-close-filters" aria-label="${theme.strings.closeFilters}"><svg aria-hidden="true" focusable="false" role="presentation" class="icon feather-x" viewBox="0 0 24 24"><path d="M18 6L6 18M6 6l12 12"></path></svg></button>
      `;

  const filterFooter = document.createElement("div");
  filterFooter.className = "cc-filter__footer md-up-hidden is-hidden";
  filterFooter.innerHTML = `<button type="button" class="btn js-close-filters">0 ${theme.strings.resultsCount.other.replace('{{ count }}', '0')}</button>`;

  // --- Mobile footer show/hide helpers ---
  let footerFirstShown = false;

  function showMobileFooter() {
    if (!filterFooter) return;

    if (!footerFirstShown) {
      footerFirstShown = true;
      // kleiner Delay für erste Slide-Animation – wie im Original
      setTimeout(showMobileFooter, 120);
      return;
    }

    filterFooter.classList.remove("is-hidden");
    // Reflow, damit die Transition greift
    void filterFooter.offsetHeight;
  }

  function hideMobileFooter() {
    if (!filterFooter) return;
    filterFooter.classList.add("is-hidden");
  }
  
  filtersInner.appendChild(filterHeader);
  filtersInner.appendChild(filtersItems);
  filtersInner.appendChild(filterFooter);

  // Event listeners for mobile header/footer buttons
  const closeBtns = filterHeader.querySelectorAll(".js-close-filters");
  const footerBtn = filterFooter.querySelector(".js-close-filters");

  [...closeBtns, footerBtn].forEach((btn) => {
    if (btn) {
      btn.addEventListener("click", () => {
        document.body.classList.remove("filters-open");
        filtersInner.classList.remove("is-open");
      });
    }
  });

  // Event listener: Clear button resets filters
  const clearBtn = filterHeader.querySelector(".js-clear-filters");
  if (clearBtn) {
    clearBtn.addEventListener("click", (e) => {
      e.preventDefault();
      const allInputs = filterContainer.querySelectorAll(
        '.cc-filter:not(.cc-filter--sort) input[type="checkbox"], .cc-filter:not(.cc-filter--sort) input[type="radio"]'
      );
      allInputs.forEach((input) => (input.checked = false));
      sectionEl.dispatchEvent(
        new CustomEvent("galakto:filter-changed", {
          bubbles: true,
          detail: {},
        })
      );
      if (typeof updateActiveFilters === "function")
        updateActiveFilters(sectionEl);
    });
  }

  // Sort element
  const sortEl = createSortFilterElement({
    index: 0,
    name: "sort_by",
    selected: "vendor-ascending",
    options: [
      { value: "vendor-ascending", label: theme.strings.vendor_ascending },
      {
        value: "vendor-descending",
        label: theme.strings.vendor_descending,
      },
      { value: "title-ascending", label: theme.strings.title_ascending },
      { value: "title-descending", label: theme.strings.title_descending },
    ],
  });
  wireSortFilter(sortEl, {
    onChange(value, label) {
      sectionEl.dispatchEvent(
        new CustomEvent("galakto:token-sort", {
          bubbles: true,
          detail: { value, label },
        })
      );
    },
  });

  // Assemble structure
  filtersContainer.appendChild(filtersInner);
  filtersContainer.appendChild(sortEl);

  // Active filter container (filled dynamically)
  const activeFiltersDiv = document.createElement("div");
  activeFiltersDiv.className = "cc-active-filters";

  // --- Collapsible for controls **and** active filters (chips) ---
  const controlsCollapsible = document.createElement("div");
  controlsCollapsible.className = "cc-filters-controls-collapsible";

  // Shared state (visible/closed)
  let controlsExpanded = false;

  controlsCollapsible.appendChild(controlDiv);

  filterContainer.appendChild(controlsCollapsible);
  filterContainer.appendChild(filtersContainer);

  filterContainer.appendChild(activeFiltersDiv);

  // Insert main container
  const availableProductsEl = sectionEl.querySelector(
    ".bndlr-sectioned-available-products"
  );
  if (availableProductsEl) {
    availableProductsEl.before(filterContainer);
  } else {
    sectionEl.prepend(filterContainer);
  }

  // === PRODUKTE SORTIEREN BEI SORTIER-ÄNDERUNG ===
  sectionEl.addEventListener("galakto:token-sort", function (event) {
    const { value } = event.detail;
    const productsContainer = sectionEl.querySelector(
      ".bndlr-sectioned-available-products"
    );
    if (!productsContainer) return;

    // Add "is-loading" class
    productsContainer.classList.add("is-loading");

    // Get all product elements
    const productNodes = Array.from(
      productsContainer.querySelectorAll(".bndlr-sectioned-product")
    );

    function getSortValue(node, key) {
      const handle = node.getAttribute("data-product-handle");
      const metafield = filteredMetafields[handle];
      if (!metafield) return "";
      if (key === "vendor") return metafield.vendor || "";
      if (key === "title") return metafield.title || "";
      return "";
    }

    let sortedNodes = productNodes.slice();

    if (value === "vendor-ascending") {
      sortedNodes.sort((a, b) =>
        getSortValue(a, "vendor").localeCompare(getSortValue(b, "vendor"))
     );
    } else if (value === "vendor-descending") {
      sortedNodes.sort((a, b) =>
        getSortValue(b, "vendor").localeCompare(getSortValue(a, "vendor"))
      );
    } else if (value === "title-ascending") {
      sortedNodes.sort((a, b) =>
        getSortValue(a, "title").localeCompare(getSortValue(b, "title"))
      );
    } else if (value === "title-descending") {
      sortedNodes.sort((a, b) =>
        getSortValue(b, "title").localeCompare(getSortValue(a, "title"))
      );
    }

    // Rearrange products in container
    sortedNodes.forEach((node) => productsContainer.appendChild(node));

    // Remove "is-loading" again after sorting
    setTimeout(() => {
      productsContainer.classList.remove("is-loading");
    }, 200); // Optional: small delay for better UX
  });

  // === DEFAULT SORTING ON FIRST LOAD (Vendor A-Z) ===
  sectionEl.dispatchEvent(
    new CustomEvent("galakto:token-sort", {
      bubbles: true,
      detail: {
        value: "vendor-ascending",
        label: theme.strings.vendor_ascending,
      },
    })
  );

  // === unified filter listener ===
  sectionEl.addEventListener("galakto:filter-changed", function () {
    applyFilters(sectionEl, filteredMetafields);
  });

  // Initial counters on first render
  setTimeout(() => applyFilters(sectionEl, filteredMetafields), 50);

  /** Collect all active checkbox/radio selections (except sort) */
  function getActiveFilters(sectionEl) {
    const container = sectionEl.querySelector(".bndlr-filter-container");
    const inputs = container.querySelectorAll(
      '.cc-filter:not(.cc-filter--sort) input[type="checkbox"]:checked, .cc-filter:not(.cc-filter--sort) input[type="radio"]:checked'
    );
    const active = {};
    inputs.forEach((i) => {
      (active[i.name] ||= []).push(i.value);
    });
    return active;
  }

  /** Apply filters to products (AND across groups, OR within group) and update UI */
  function applyFilters(sectionEl, filteredMetafields) {
    const active = getActiveFilters(sectionEl);

    const productsContainer = sectionEl.querySelector(
      ".bndlr-sectioned-available-products"
    );
    if (!productsContainer) return;

    const productNodes = Array.from(
      productsContainer.querySelectorAll(".bndlr-sectioned-product")
    );

    productNodes.forEach((node) => {
      const handle = node.getAttribute("data-product-handle");
      const mf = filteredMetafields[handle];
      let visible = true;

      for (const [name, values] of Object.entries(active)) {
        if (!values.length) continue;

        let fieldValue = "";
        if (name === "filter.p.m.custom.altersempfehlung")
          fieldValue = String(mf?.altersempfehlung ?? "");
        else if (name === "filter.p.vendor")
          fieldValue = String(mf?.vendor ?? "");
        else if (name === "filter.p.m.custom.hoerrichtung")
          fieldValue = String(mf?.hoerrichtung ?? "");
        else if (name === "filter.p.product_type")
          fieldValue = String(mf?.productType ?? "");
        else continue;

        if (!values.includes(fieldValue)) {
          visible = false;
          break;
        }
      }

      node.style.display = visible ? "" : "none";
    });

    renderActiveFilters(sectionEl, active);
    updateHeadersAndCounts(sectionEl, active);
    updateFilterCounts(sectionEl, filteredMetafields); // Your existing function
  }

  /** Build/refresh the chips ("active filters") from the full active set */
  function renderActiveFilters(sectionEl, active) {
    const container = sectionEl.querySelector(".bndlr-filter-container");
    const parent = container.querySelector(".cc-filters-controls-collapsible") || container;

    let box = parent.querySelector(".cc-active-filters");
    if (!box) {
      box = document.createElement("div");
      box.className = "cc-active-filters";
      parent.appendChild(box); // <— Write into collapsible area
    }

    const items = [];
    Object.entries(active).forEach(([name, values]) => {
      values.forEach((value) => {
        const input = container.querySelector(
          `input[name="${CSS.escape(name)}"][value="${CSS.escape(value)}"]`
        );
        const label = input
          ? container
              .querySelector(`label[for="${input.id}"] .cc-filter-label`)
              ?.textContent?.trim() || value
          : value;
        items.push({ name, value, label });
      });
    });

    if (!items.length) {
      box.innerHTML = "";
      return;
    }

    box.innerHTML = `
    <div class="cc-active-filters__scroller">
      <div class="cc-active-filters__items">
        <a href="#" class="cc-active-filter-reset">${theme.strings.clearAllFilters}</a>
        ${items
          .map(
            (f) => `
          <a href="#" class="cc-active-filter" data-filter-name="${f.name}" data-filter-value="${f.value}">
            ${f.label}
            <svg aria-hidden="true" focusable="false" role="presentation" class="icon feather-x" viewBox="0 0 24 24"><path d="M18 6L6 18M6 6l12 12"></path></svg>
          </a>
        `
          )
          .join("")}
      </div>
    </div>
  `;

    // Reset all
    box
      .querySelector(".cc-active-filter-reset")
      ?.addEventListener("click", (e) => {
        e.preventDefault();
        container
          .querySelectorAll(
            '.cc-filter:not(.cc-filter--sort) input[type="checkbox"], .cc-filter:not(.cc-filter--sort) input[type="radio"]'
          )
          .forEach((i) => (i.checked = false));
        sectionEl.dispatchEvent(
          new CustomEvent("galakto:filter-changed", {
            bubbles: true,
            detail: {},
          })
        );
      });

    // Remove single chip
    box.querySelectorAll(".cc-active-filter").forEach((chip) => {
      chip.addEventListener("click", (e) => {
        e.preventDefault();
        const name = chip.getAttribute("data-filter-name");
        const value = chip.getAttribute("data-filter-value");
        const input = container.querySelector(
          `input[name="${CSS.escape(name)}"][value="${CSS.escape(value)}"]`
        );
        if (input) input.checked = false;
        sectionEl.dispatchEvent(
          new CustomEvent("galakto:filter-changed", {
            bubbles: true,
            detail: {},
          })
        );
      });
    });
  }

  /** Update group headers (selection count), list header result-counter, and mobile footer button */
  function updateHeadersAndCounts(sectionEl, active) {
    const productsContainer = sectionEl.querySelector(
      ".bndlr-sectioned-available-products"
    );
    const all = Array.from(
      productsContainer.querySelectorAll(".bndlr-sectioned-product")
    );
    const visibleCount = all.filter((n) => n.style.display !== "none").length;

    const container = sectionEl.querySelector(".bndlr-filter-container");

    container
      .querySelectorAll(".cc-filter:not(.cc-filter--sort)")
      .forEach((filterEl) => {
        const header = filterEl.querySelector(".cc-filter__header");
        const countDiv = header?.querySelector(".cc-filter-count");
        if (countDiv) countDiv.textContent = `${visibleCount} ${visibleCount === 1 ? theme.strings.resultsCount.one.replace('{{ count }}', visibleCount) : theme.strings.resultsCount.other.replace('{{ count }}', visibleCount)}`;

        const summary = filterEl.querySelector("summary");
        const firstInput = filterEl.querySelector(
          'input[type="checkbox"], input[type="radio"]'
        );
        const groupName = firstInput?.name || "";
        const selectedInGroup = active[groupName]?.length || 0;

        if (summary) {
          if (!summary.dataset.title)
            summary.dataset.title = summary.textContent.replace(
              /\s*\(\d+\)$/,
              ""
            );
          summary.textContent =
            selectedInGroup > 0
              ? `${summary.dataset.title} (${selectedInGroup})`
              : summary.dataset.title;
        }

        const clearBtn = filterEl.querySelector(".cc-filter-clear-btn");
        if (clearBtn) {
          clearBtn.toggleAttribute("hidden", selectedInGroup === 0);
          clearBtn.onclick = (e) => {
            e.preventDefault();
            filterEl
              .querySelectorAll(
                'input[type="checkbox"]:checked, input[type="radio"]:checked'
              )
              .forEach((i) => (i.checked = false));
            sectionEl.dispatchEvent(
              new CustomEvent("galakto:filter-changed", {
                bubbles: true,
                detail: {},
              })
            );
          };
        }
      });

    const footerEl  = sectionEl.querySelector(".cc-filter__footer");
    const footerBtn = footerEl?.querySelector(".js-close-filters");
    if (footerBtn) {
      footerBtn.textContent = `${visibleCount} ${visibleCount === 1 ? theme.strings.resultsCount.one.replace('{{ count }}', visibleCount) : theme.strings.resultsCount.other.replace('{{ count }}', visibleCount)}`;
    }

    const totalSelected = Object.values(active).reduce((s, arr) => s + (arr?.length || 0), 0);

    // Slide-show/hide like in theme
    if (footerEl) {
      if (totalSelected > 0) {
        showMobileFooter();
      } else {
        hideMobileFooter();
      }
    }

    // Update "Verfeinern (n)" button
    const mobileRefineBtn = sectionEl.querySelector(".cc-filters-control .js-show-filters");
    if (mobileRefineBtn) {
      const base = mobileRefineBtn.dataset.baseLabel || mobileRefineBtn.textContent.replace(/\s*\(\d+\)$/, "").trim();
      mobileRefineBtn.dataset.baseLabel = base;
      mobileRefineBtn.textContent = totalSelected > 0 ? `${base} (${totalSelected})` : base;
    }
  }

  // Add button only if not already present
  const descContainer = sectionEl.querySelector(".bndlr-section-description");
  if (descContainer && !descContainer.querySelector(".toggle-filters")) {
    const btn = document.createElement("button");
    btn.className =
      "btn btn--secondary btn--small toggle-filters toggle-filters--token-section";
    btn.setAttribute("data-toggle-filters", "");

    btn.innerHTML = `
          <svg class="icon icon--stroke-only icon--medium icon--type-filter" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" aria-hidden="true" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <line x1="3" y1="8" x2="21" y2="8"></line>
            <circle cx="7" cy="8" r="2" fill="none"></circle>
            <line x1="3" y1="16" x2="21" y2="16"></line>
            <circle cx="17" cy="16" r="2" fill="none"></circle>
          </svg>
          <span class="toggle-filters__text toggle-filters__text--active">${theme.strings.showFilters}</span>
          <span class="toggle-filters__text toggle-filters__text--inactive">${theme.strings.hideFilters}</span>
        `;
    descContainer.appendChild(btn);

    // --- Toggle: Filter & Sort <-> Hide filters ---
    function expandControls() {
      controlsExpanded = true;
      btn.classList.add("is-active");
      filterContainer.classList.add("is-controls-open");
    }

    function collapseControls() {
      controlsExpanded = false;
      btn.classList.remove("is-active");
      filterContainer.classList.remove("is-controls-open");
    }

    btn.addEventListener("click", (e) => {
      e.preventDefault();
      controlsExpanded ? collapseControls() : expandControls();
    });

    // Start: Controls collapsed
    collapseControls();
  }
}

/**
 * Generate filter configurations based on actual product metafields
 * @param {Object} productMetafields - Product metafields data
 * @returns {Array} Filter configurations
 */
function generateFilterConfigs(productMetafields) {
  const configs = [];

  // Age filter
  const ages = new Map();
  Object.values(productMetafields).forEach((product) => {
    if (product.altersempfehlung) {
      const age = product.altersempfehlung.toString();
      ages.set(age, (ages.get(age) || 0) + 1);
    }
  });

  if (ages.size > 0) {
    configs.push({
      title: theme.strings.filterByAge,
      name: "filter.p.m.custom.altersempfehlung",
      options: Array.from(ages.entries())
        .sort(([a], [b]) => parseInt(a) - parseInt(b))
        .map(([value, count]) => ({ value, label: value, count })),
    });
  }

  // Vendor filter
  const vendors = new Map();
  Object.values(productMetafields).forEach((product) => {
    if (product.vendor) {
      vendors.set(product.vendor, (vendors.get(product.vendor) || 0) + 1);
    }
  });

  if (vendors.size > 0) {
    configs.push({
      title: theme.strings.filterByCharacter,
      name: "filter.p.vendor",
      options: Array.from(vendors.entries())
        .sort(([a], [b]) => a.localeCompare(b))
        .map(([value, count]) => ({ value, label: value, count })),
    });
  }

  // Theme filter (hoerrichtung)
  const themes = new Map();
  Object.values(productMetafields).forEach((product) => {
    if (product.hoerrichtung) {
      themes.set(
        product.hoerrichtung,
        (themes.get(product.hoerrichtung) || 0) + 1
      );
    }
  });

  if (themes.size > 0) {
    configs.push({
      title: theme.strings.filterByTheme,
      name: "filter.p.m.custom.hoerrichtung",
      options: Array.from(themes.entries())
        .sort(([a], [b]) => a.localeCompare(b))
        .map(([value, count]) => ({ value, label: value, count })),
    });
  }

  // Product Type filter
  const types = new Map();
  Object.values(productMetafields).forEach((product) => {
    if (product.productType) {
      types.set(product.productType, (types.get(product.productType) || 0) + 1);
    }
  });

  if (types.size > 0) {
    configs.push({
      title: theme.strings.filterByGenre,
      name: "filter.p.product_type",
      options: Array.from(types.entries())
        .sort(([a], [b]) => a.localeCompare(b))
        .map(([value, count]) => ({ value, label: value, count })),
    });
  }

  return configs;
}

/**
 * Creates a checkbox filter element similar to Shopify's facet filters
 * @param {Object} cfg
 * @param {number} cfg.index
 * @param {string} cfg.title
 * @param {string} cfg.name
 * @param {{value:string,label:string,count:number}[]} cfg.options
 * @returns {HTMLElement}
 */
function createCheckboxFilterElement({
  index = 1,
  title = "Filter",
  name = "filter",
  options = [],
} = {}) {
  const details = document.createElement("details");
  details.className = "cc-filter";
  details.setAttribute("data-type", "list");
  details.setAttribute("data-index", String(index));

  // Summary/Toggle
  const summary = document.createElement("summary");
  summary.className = "cc-filter__toggle";
  summary.textContent = title;
  details.appendChild(summary);

  // Panel
  const panel = document.createElement("div");
  panel.className = "cc-filter__panel";
  panel.innerHTML = `
    <div class="cc-filter__content">
      <ul class="cc-filter__list"></ul>
    </div>
  `;

  // Header according to your example - shows current results
  const header = document.createElement("div");
  header.className = "cc-filter__header";
  header.innerHTML = `
    <div class="cc-filter-heading md-up-hidden">${title}</div>
    <div class="md-down-hidden cc-filter-count">${options.reduce(
      (sum, o) => sum + o.count,
      0
    )} ${theme.strings.resultsCount.other.replace('{{ count }}', options.reduce((sum, o) => sum + o.count, 0))}</div>
    <a href="#" class="cc-filter-clear-btn" hidden>${theme.strings.clearFilter}</a>
    <button type="button" class="cc-filter-back-btn feather-icon md-up-hidden" aria-label="${theme.strings.backButton}">
      <svg aria-hidden="true" focusable="false" role="presentation" class="icon feather-chevron-left" viewBox="0 0 24 24"><path d="M15 18l-6-6 6-6"></path></svg>
    </button>
  `;
  panel.prepend(header);

  details.appendChild(panel);

  const list = panel.querySelector(".cc-filter__list");

  options.forEach((opt, i) => {
    const id = `cc-filter-${title.replace(/\s+/g, "")}-${i + 1}`;
    const li = document.createElement("li");
    li.innerHTML = `
      <input type="checkbox" class="checkbox" id="${id}" name="${name}" value="${opt.value}">
      <label for="${id}">
        <span class="cc-filter-label">${opt.label}</span>
        <span>${opt.count}</span>
      </label>
    `;
    list.appendChild(li);
  });

  return details;
}

/**
 * Wire events for checkbox filter elements
 * @param {HTMLElement} detailsEl
 * @param {Object} options
 */
function wireCheckboxFilter(detailsEl, { onChange } = {}) {
  const list = detailsEl.querySelector(".cc-filter__list");
  const toggle = detailsEl.querySelector(".cc-filter__toggle");
  const clearBtn = detailsEl.querySelector(".cc-filter-clear-btn");
  const backBtn = detailsEl.querySelector(".cc-filter-back-btn");

  // Handle back button (mobile header)
  if (backBtn) {
    backBtn.addEventListener("click", (e) => {
      e.preventDefault();
      if (!detailsEl.open) return;

      // Close panel with same transition as toggle
      detailsEl.classList.remove("is-open");
      detailsEl.classList.add("is-closing");
      setTimeout(() => {
        detailsEl.open = false;
        detailsEl.classList.remove("is-closing");
      }, 300);
    });
  }

  // Handle checkbox changes
  list.addEventListener("change", (e) => {
    if (e.target.type === "checkbox") {
      const selectedValues = Array.from(
        list.querySelectorAll('input[type="checkbox"]:checked')
      ).map((cb) => cb.value);

      // Show/hide clear button
      if (clearBtn) {
        if (selectedValues.length > 0) {
          clearBtn.removeAttribute("hidden");
        } else {
          clearBtn.setAttribute("hidden", "");
        }
      }

      if (typeof onChange === "function") {
        onChange(selectedValues);
      }
    }
  });

  // Handle toggle click with accordion behavior
  if (toggle) {
    toggle.addEventListener("click", (e) => {
      e.preventDefault();

      if (detailsEl.open) {
        // Close
        detailsEl.classList.remove("is-open");
        detailsEl.classList.add("is-closing");

        setTimeout(() => {
          detailsEl.open = false;
          detailsEl.classList.remove("is-closing");
        }, 300);
      } else {
        // Open
        detailsEl.open = true;

        setTimeout(() => {
          detailsEl.classList.add("is-open");
        }, 10);
      }
    });
  }

  // Handle clear button
  if (clearBtn) {
    clearBtn.addEventListener("click", (e) => {
      e.preventDefault();
      list.querySelectorAll('input[type="checkbox"]:checked').forEach((cb) => {
        cb.checked = false;
      });
      clearBtn.setAttribute("hidden", "");

      if (typeof onChange === "function") {
        onChange([]);
      }
    });
  }

  // Handle clear button (clear this group only, then trigger global apply)
  if (clearBtn) {
    clearBtn.addEventListener("click", (e) => {
      e.preventDefault();
      list
        .querySelectorAll(
          'input[type="checkbox"]:checked, input[type="radio"]:checked'
        )
        .forEach((cb) => {
          cb.checked = false;
        });
      clearBtn.setAttribute("hidden", "");
      // Trigger global listener – not just onChange of the group
      detailsEl.dispatchEvent(
        new CustomEvent("galakto:filter-changed", { bubbles: true, detail: {} })
      );
    });
  }

  // Close when clicking outside
  document.addEventListener("click", (e) => {
    if (!detailsEl.contains(e.target) && detailsEl.open) {
      detailsEl.classList.remove("is-open");
      detailsEl.classList.add("is-closing");

      setTimeout(() => {
        detailsEl.open = false;
        detailsEl.classList.remove("is-closing");
      }, 300);
    }
  });
}

/**
 * Creates a <details> element for sorting in the shown style.
 * @param {Object} cfg
 * @param {number} cfg.index
 * @param {string} cfg.name
 * @param {string} cfg.selected
 * @param {{value:string,label:string}[]} cfg.options
 * @returns {HTMLElement}
 */
function createSortFilterElement({
  index = 0,
  name = "sort_by",
  selected = "best-selling",
  options = [],
} = {}) {
  const details = document.createElement("details");
  details.className = "cc-filter cc-filter--sort";
  details.setAttribute("data-index", String(index));

  // Summary/Toggle
  const summary = document.createElement("summary");
  summary.className = "cc-filter__toggle";
  summary.innerHTML = `
        <span class="cc-sort-label md-down-hidden">${theme.strings.sortTitle}</span>
        <span class="cc-sort-selected md-down-hidden"></span>
      `;
  details.appendChild(summary);

  const panel = document.createElement("div");
  panel.className = "cc-filter__panel";
  panel.innerHTML = `
        <div class="cc-filter__header md-up-hidden">
          <div class="cc-filter-heading">${theme.strings.sortTitle}</div>
          <button type="button" class="cc-filter-close-btn feather-icon js-close-filters" aria-label="${theme.strings.closeFilters}">
            <svg aria-hidden="true" focusable="false" role="presentation" class="icon feather-x" viewBox="0 0 24 24"><path d="M18 6L6 18M6 6l12 12"></path></svg>
          </button>
        </div>
        <div class="cc-filter__content">
          <ul class="cc-filter__list"></ul>
        </div>
        <div class="cc-filter__footer md-up-hidden">
          <button type="button" class="btn js-close-filters">${theme.strings.applyFilters}</button>
        </div>
      `;
  details.appendChild(panel);

  const list = panel.querySelector(".cc-filter__list");

  options.forEach((opt, i) => {
    const id = `${name}-${index + 1}-${i + 1}`;
    const li = document.createElement("li");
    li.innerHTML = `
          <input type="radio" class="radio" id="${id}" name="${name}" value="${opt.value}">
          <label for="${id}">${opt.label}</label>
        `;
    const input = li.querySelector("input");
    if (opt.value === selected) input.checked = true;
    list.appendChild(li);
  });

  // Set initial selected text
  const selectedSpan = details.querySelector(".cc-sort-selected");
  const checked = list.querySelector(`input[name="${name}"]:checked`);
  if (selectedSpan && checked) {
    const lbl = list.querySelector(`label[for="${checked.id}"]`);
    selectedSpan.textContent = lbl ? lbl.textContent : "";
  }
  return details;
}

/**
 * Wire events for the sort details element.
 * Updates the selected display and closes panels on mobile.
 */
function wireSortFilter(detailsEl, { onChange } = {}) {
  const selectedSpan = detailsEl.querySelector(".cc-sort-selected");
  const list = detailsEl.querySelector(".cc-filter__list");
  const toggle = detailsEl.querySelector(".cc-filter__toggle");

  list.addEventListener("change", (e) => {
    const input = e.target.closest('input[type="radio"]');
    if (!input) return;
    const label = list.querySelector(`label[for="${input.id}"]`);
    if (selectedSpan && label) {
      selectedSpan.textContent = label.textContent || "";
    }
    if (typeof onChange === "function") {
      onChange(input.value, label ? label.textContent : "");
    }
  });

  // Handle toggle click with accordion behavior
  if (toggle) {
    toggle.addEventListener("click", (e) => {
      e.preventDefault();

      if (detailsEl.open) {
        // Close
        detailsEl.classList.remove("is-open");
        detailsEl.classList.add("is-closing");

        setTimeout(() => {
          detailsEl.open = false;
          detailsEl.classList.remove("is-closing");
        }, 300);
      } else {
        // Open
        detailsEl.open = true;

        setTimeout(() => {
          detailsEl.classList.add("is-open");
        }, 10);
      }
    });
  }

  // Close buttons: close panel
  detailsEl.querySelectorAll(".js-close-filters").forEach((btn) => {
    btn.addEventListener("click", (e) => {
      e.preventDefault();

      detailsEl.classList.remove("is-open");
      document.body.classList.remove("filters-open");
      detailsEl.classList.add("is-closing");

      setTimeout(() => {
        detailsEl.open = false;
        detailsEl.classList.remove("is-closing");
      }, 300);
    });
  });

  // Close when clicking outside
  document.addEventListener("click", (e) => {
    if (!detailsEl.contains(e.target) && detailsEl.open) {
      detailsEl.classList.remove("is-open");
      detailsEl.classList.add("is-closing");

      setTimeout(() => {
        detailsEl.open = false;
        detailsEl.classList.remove("is-closing");
      }, 300);
    }
  });
}
